import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {CockpitCard} from 'shared/dtos/cockpit-card';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {
  CockpitChartComponent,
  CockpitChartParentComponent,
  CockpitContentComponent
} from '../../cockpit-shared/cockpit-content-component';
import {ChartDialogFunktionswertComponent} from './chart-dialog-funktionswert/chart-dialog-funktionswert.component';
import {ChartDialogLohnbandComponent} from './chart-dialog-lohnband/chart-dialog-lohnband.component';

@Component({
  selector: 'app-funktionswert',
  templateUrl: './funktionswert.component.html',
  styleUrls: [
    './funktionswert.component.scss',
    '../../cockpit-shared/card/card.component.scss'
  ],
  standalone: false
})
export class FunktionswertComponent
  extends CockpitChartParentComponent
  implements OnInit, AfterViewInit, CockpitContentComponent
{
  @ViewChild(ChartDialogFunktionswertComponent)
  chartDialogFunktionswert!: CockpitChartComponent;
  @ViewChild(ChartDialogLohnbandComponent)
  chartDialogLohnband!: CockpitChartComponent;

  chartChildren: CockpitChartComponent[];
  card: CockpitCard;

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
  async ngOnInit(): Promise<void> {}

  ngAfterViewInit(): void {
    this.chartChildren = [
      this.chartDialogFunktionswert,
      this.chartDialogLohnband
    ];
  }
}
